module.exports = __webpack_public_path__ + "static/media/SWU_logo.b42aff41.svg";